<template>
  <section class="home-standard home-customerreview text-center">
    <div class="site-width quote-carousel-container">
      <h2>What Customers Are Saying</h2>
      <client-only>
        <carousel v-bind="carouselOptions">
          <slide v-for="(quote, index) in quotes" :key="index">
            <figure>
              <blockquote>{{ quote.quote }}</blockquote>
              <figcaption>— {{ quote.author_name }}</figcaption>
            </figure>
          </slide>
        </carousel>
      </client-only>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CustomerOpinionSection',
  data() {
    return {
      quotes: [],
      carouselOptions: {
        autoplay: 10000,
        perPage: 1,
        loop: true,
        navigationEnabled: true,
        navigationNextLabel: '',
        navigationPrevLabel: '',
      },
    }
  },
  mounted() {
    this.fetchQuotes()
  },
  methods: {
    async fetchQuotes() {
      try {
        this.quotes = (
          await this.$axios.get('/api/homepage/quotes')
        ).data.quotes
      } catch (error) {
        console.error('Unable to fetch quotes data', error)
      }
    },
  },
}
</script>
